/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'trash': {
    width: 210,
    height: 221,
    viewBox: '0 0 210 221',
    data: '<defs/><path pid="0" id="trash" class="cls-1" d="M2613.33 1018.74a23.33 23.33 0 0 0 23.34 23.26h116.66a23.33 23.33 0 0 0 23.34-23.26V879.158h-163.34v139.582zm23.34-116.319h116.66l.02 116.319h-116.68V902.421zm93.33-58.158V821h-70v23.263h-70v23.263h210v-23.263h-70zm-70 151.211h23.33v-69.79H2660v69.79zm46.67 0H2730v-69.79h-23.33v69.79z" transform="translate(-2590 -821)"/>'
  }
})
